import { gql } from 'graphql-request';

export const getUser = gql`
  query GetUser($username: String!) {
    getUser(username: $username) {
      id
      username
      email
    }
  }
`;

export const getUsers = gql`
  query GetUsers($page: Int = 1, $pageSize: Int = 10) {
    getUsers(page: $page, pageSize: $pageSize) {
      id
      username
      email
    }
  }
`;

export const createUser = gql`
  mutation CreateUser($username: String!, $email: String!, $password: String!) {
    createUser(username: $username, email: $email, password: $password) {
      id
      username
      email
    }
  }
`;

export const updateUser = gql`
  mutation UpdateUser($username: String!, $email: String, $password: String) {
    updateUser(username: $username, email: $email, password: $password) {
      id
      username
      email
    }
  }
`;

export const deleteUser = gql`
  mutation DeleteUser($username: String!) {
    deleteUser(username: $username)
  }
`;

export const authenticateUser = gql`
  mutation AuthenticateUser($idToken: String!) {
    authenticateUser(idToken: $idToken) {
      id
      username
      email
    }
  }
`;

export const createOrUpdateUser = gql`
  mutation CreateOrUpdateUser(
    $uid: String!
    $email: String!
    $displayName: String
  ) {
    createOrUpdateUser(uid: $uid, email: $email, displayName: $displayName) {
      id
      email
      username
      firstName
      lastName
      isStaff
    }
  }
`;
